window.FullioUrlState = {
    get: name => new URLSearchParams(window.location.hash.slice(1)).get(name) ?? '',
    // Select values not present among the options fall back to the empty option
    fill: (field, value) => {
        field.value = field instanceof HTMLSelectElement && !Array.from(field.options).some(option => option.value === value) ? '' : value;
    },
    replace: params => {
        const hash = new URLSearchParams(window.location.hash.slice(1));
        Object.entries(params).forEach(([name, value]) => {
            if (value === '' || value === null || value === undefined) hash.delete(name);
            else hash.set(name, String(value));
        });
        const value = hash.toString();
        const url = window.location.pathname + window.location.search + (value ? `#${value}` : '');
        if (url !== window.location.pathname + window.location.search + window.location.hash) history.replaceState(history.state, '', url);
    }
};

// A back link returns to the list it came from with its filters (kept in the hash),
// and falls back to its href when the page was opened directly.
document.addEventListener('click', event => {
    const link = event.target.closest('a[data-history-back]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let referrer;
    try { referrer = new URL(document.referrer); } catch (error) { return; }
    if (referrer.origin !== window.location.origin || referrer.pathname !== new URL(link.href).pathname) return;
    event.preventDefault();
    history.back();
});
